export default __webpack_public_path__ + "static/media/board_and_card_games.f1013af6.jpeg";